import { useAiAccessControls } from '../../../shared/hooks/queries/useAiAccessControls';
const hasAgentsAccess = (accessControls, variant) => {
  if (!accessControls) {
    return false;
  }
  const agentsAccess = accessControls.generativeAiEnabled && accessControls.crmPropertiesEnabled && accessControls.conversationDataEnabled && accessControls.fileDataEnabled;
  const assistantAccess = agentsAccess && accessControls.copilotEnabled;
  return variant === 'AGENT' ? agentsAccess : assistantAccess;
};
/**
 * This hook is used to check if the user has access to activating, running and creating agents.
 * Returns a boolean value indicating if the user has access to the necessary controls.
 *
 * The user must have access to all of the following from the AI Settings page:
 * - Generative AI
 * - CRM Properties
 * - Conversation Data
 * - File Data
 */
export const useAgentsAccess = (variant = 'AGENT', options = {}) => {
  const {
    accessControls,
    loading,
    error,
    refetch
  } = useAiAccessControls(options);
  return {
    hasAgentsAccess: hasAgentsAccess(accessControls, variant),
    loading,
    error,
    refetch
  };
};